module.exports = __webpack_public_path__ + "media/images/pic/anime/school-84d93ddd47b829bb15f837a636658bca.svg";